module.exports = __webpack_public_path__ + "img/leak_sensor.f03ebc91.svg";